module.exports = __webpack_public_path__ + "img/protection.00875ee0.svg";